import React from 'react';

/**
 * PageToolbar — standard action/filter row (48px rhythm).
 */
const PageToolbar = ({ children, className = '', split = false, align = 'end' }) => {
  const classes = [
    'ads-page-toolbar',
    'page-toolbar',
    split ? 'ads-page-toolbar--split page-toolbar--split' : '',
    align === 'start' ? 'ads-page-toolbar--start' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classes}>{children}</div>;
};

export default PageToolbar;
